<script setup lang="ts">
/** Prerendered marketing landing. Composition of components/landing/*, no data plane. */
import LandingHero from '~/components/landing/LandingHero.vue'
import LandingLoop from '~/components/landing/LandingLoop.vue'
import LandingCapabilities from '~/components/landing/LandingCapabilities.vue'
import LandingDevelopers from '~/components/landing/LandingDevelopers.vue'
import LandingRates from '~/components/landing/LandingRates.vue'
import LandingClose from '~/components/landing/LandingClose.vue'

definePageMeta({ layout: 'public' })
</script>

<template>
  <main>
    <LandingHero />
    <LandingLoop />
    <LandingCapabilities />
    <LandingDevelopers />
    <LandingRates />
    <LandingClose />
  </main>
</template>
